export default "__VITE_ASSET__BQvPloR9__"